<h3 class="soft-text-l ml-2 mr-2">Legierung auswählen</h3>
<p class="soft-text color-light ml-2 mr-2">Bitte wählen Sie die gewünschte Legierung durch tippen aus.</p>

<ul>
    <li *ngFor="let legierung of legierungen; let last = last" class="list-item" (click)="close(legierung)" [ngClass]="last ? '' : 'border-b'">
        <span class="soft-text">{{ legierung.legierung }}</span>
        <span class="soft-text-s color-light" *ngIf="legierung?.bezeichnung">{{ legierung.bezeichnung }}</span>
    </li>
</ul>

<button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
